<script setup lang="ts">
import { useCart } from '@/composables/useCart'
//import { MockCartService } from '@/services/mockCartService'
import { LiveCartService } from '@/services/liveCartService'
import { ref } from 'vue'
import { useConfig } from '@/composables/useConfig'

//const cart = useCart(new MockCartService()) // swap with LiveCartService(userId) in production
const cart = useCart(new LiveCartService()) 

//const product = { productId: "1-1", name: 'Coffee Mug', priceNet: 12.99, quantity: 1 }

const showConfirmFlag = ref(false)
const showConfirmMsg = ref("Törlés?")
const confirmCallback = ref<(() => void)>(() => {}) // ref<(() => void)>(() => {})

const emptyCart = () => {
  cart.clearCart()
  showConfirmFlag.value = false
}

const askConfirm = (msg: string, callback:  () => void) => {
  showConfirmMsg.value = msg
  showConfirmFlag.value = true
  confirmCallback.value = callback
}

const config = useConfig()

</script>

<template>
  <button v-if="config.runMode==='dev'" @click="cart.addProdItem('1-2535579', 1); cart.addProdItem('1-2530080', 2)">Add to Cart</button>
  <table class="cart">
    <thead>
      <tr>
        <th></th>
        <th class="lalign">Termék</th><th class="ralign">mennyiség</th><th class="ralign">Ár<br>ÁFA-val</th>
        <th v-if="cart.hasDiscounts()">Discount %</th>
        <th>Készlet</th>
        <th></th><th></th><th></th>
      </tr>
    </thead>
    <tbody>
    <tr v-for="item in cart.cart.items" :key="item.cartItemId" class="cart-item">
      <td><a :href="`${config.productPageBaseUrl}/product/${item.productId}`"><img :src="`${config.productImageBaseUrl}/${item.imageUrl}`"></a></td>
      <td class="lalign" :class="{strikethrough: item.qty===0}">
        <a :href="`${config.productPageBaseUrl}/product/${item.productId}`">{{ item.name }}</a>
        <br v-if="item.description">
        <a :href="`/product/${item.productId}`">{{ item.description ? item.description : '' }}</a>
        <br>
        <small>{{ item.sku }} </small>

      </td>
      <td class="ralign">{{ item.qty }} db</td>
      <td :class="{strikethrough: item.qty===0}">{{ item.priceGross }}.-</td>
      <td class="ralign" v-if="cart.hasDiscounts()">{{ item.custDiscountPct }}</td>
      <td>{{ item.localStockInfo}}</td>
      <td><button @click="cart.changeItemQuantity(item, -1)">-</button></td>
      <td><button @click="cart.changeItemQuantity(item, 1)">+</button></td>
      
      <!--<td><button @click="cart.removeItem(item.cartItemId)">x</button></td> -->
      <td><button @click="askConfirm('Törlöd a tételt?', () => cart.removeItem(item.productId))">x</button></td> 
    </tr>
    </tbody>
  </table>
  <!-- <button @click="showConfirmFlag = true">Clear</button> -->
  <button @click="askConfirm('Biztosan kiüríted a kosarat?', emptyCart)">Kosár ürítése</button>


  <div v-if="showConfirmFlag" class="modal">
    <div class="modal-content">
      <p>{{ showConfirmMsg}}</p>
      <button @click="() => { confirmCallback(); showConfirmFlag = false }">Igen</button>
      <button @click="showConfirmFlag = false">Mégsem</button>
    </div>
  </div>  

</template>

<style scoped>
.modal {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal-content {
  background: white;
  padding: 1rem 2rem;
  border-radius: 8px;
}
</style>  

